import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 bg-cream-50" data-id="element-11">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-12">
        <span className="inline-block px-4 py-1.5 bg-gold-100 text-gold-600 rounded-full text-sm font-bold tracking-wide uppercase mb-6" data-id="element-13">
          Make It Easy
        </span>

        <h2 className="text-4xl md:text-5xl font-heading text-petrol-700 mb-6 leading-tight" data-id="element-14">
          The Speaker is Critical. <br className="hidden md:block" data-id="element-15" />
          The Process Shouldn't Be.
        </h2>

        <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-16">
          We make it easy to choose a speaker who's already done the work — in
          real rooms, with real results. That's what makes them a Goldspeaker.
        </p>

        <div className="bg-white p-8 rounded-2xl shadow-lg border border-cream-200 inline-block w-full max-w-2xl" data-id="element-17">
          <h3 className="text-2xl font-heading text-navy-900 mb-8" data-id="element-18">
            Ready to brief us?
          </h3>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-19">
            <button className="flex-1 bg-gold-500 hover:bg-gold-400 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors shadow-md" data-id="element-20">
              Request a Speaker Match
            </button>
            <button className="flex-1 bg-transparent border-2 border-petrol-600 text-petrol-700 hover:bg-petrol-50 px-8 py-4 rounded-lg font-semibold text-lg transition-colors" data-id="element-21">
              Book a Discovery Call
            </button>
          </div>
        </div>
      </div>
    </section>;
}